import ChatWindow from "src/App/AppLayouts/Shared/AIChat/ChatWindow";
import { MobilePageBase } from "../Shared/MobilePageBase/MobilePage";

export function AiChatPage() {
    return <MobilePageBase><ChatWindow/></MobilePageBase>
}